import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

export function PermissionGate({ permissions, children, fallback = null }) {
  const { hasAnyPermission } = useAuth()
  return hasAnyPermission(permissions) ? children : fallback
}

export function PermissionRoute({ permissions, children }) {
  const { hasAnyPermission } = useAuth()
  const location = useLocation()

  if (!hasAnyPermission(permissions)) {
    return (
      <Navigate
        to='/access-denied'
        state={{ from: location.pathname }}
        replace
      />
    )
  }

  return children
}
